interface CustomFileInputProps {
  id: string
  label: string
  accept: string
  value: File | null
  error?: string
  onChange: (file: File | null) => void
}

export const CustomFileInput = ({
  id,
  label,
  accept,
  value,
  error,
  onChange,
}: CustomFileInputProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <label
      htmlFor={id}
      style={{
        color: '#344054',
        fontSize: 14,
        fontWeight: 500,
      }}
    >
      {label}
    </label>

    <div
      style={{
        display: 'flex',
        borderRadius: 8,
        overflow: 'hidden',
        // no border as requested
      }}
    >
      {/* Left side: Choose File */}
      <label
        htmlFor={id}
        style={{
          backgroundColor: 'var(--color-kycbtn-Choose)',
          color: '#fff',
          fontSize: 13,
          fontWeight: 400,
          padding: '10px 12px',
          width: 101,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        Choose File
      </label>

      {/* Right side: Selected file or placeholder */}
      <div
        style={{
          flex: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          color: '#475467',
          fontSize: 13,
          fontWeight: 400,
          padding: '10px 12px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'block',
            width: '100%',
          }}
          title={value ? value.name : 'No file chosen'}
        >
          {value ? value.name : 'No file chosen'}
        </span>
      </div>
    </div>

    {/* Hidden file input */}
    <input
      id={id}
      type='file'
      accept={accept}
      style={{ display: 'none' }}
      onChange={(e) => onChange(e.target.files?.[0] || null)}
    />

    {error && (
      <p
        style={{
          color: '#f03e3e',
          fontSize: 12,
          marginTop: 4,
        }}
      >
        {error}
      </p>
    )}
  </div>
)
